import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import ChatSVG from '../assets/images/icons/chat.svg';

const OnlineSupport = ({ toggleHelpDeskProps }) => {

    return (

        <React.Fragment>

            <Box
                className={`d-flex flex-wrap justify-content-between my-xxl mt-0 p-xl rounded-lg`}
                ms={{
                    backgroundColor: 'var(--blue-ultra-light)'
                }}>
                <Box
                    className={`w-75`}
                    ms={{
                        '@media(max-width:576px)': {
                            width: '100% !important'
                        }
                    }}>
                    <Typography
                        className={`d-block`}
                        component='h5'>
                        درخواست پشتیبانی آنلاین
                    </Typography>
                    <Typography>
                        هرگونه درخواستی در رابطه با رزروهای خود دارید، با ما مطرح کنید
                    </Typography>
                </Box>
                <Button
                    onClick={toggleHelpDeskProps}
                    className={`align-self-center`}
                    color='primary'
                    iconStart={ChatSVG}
                    ms={{
                        width: '208px',
                        '@media(max-width:576px)': {
                            width: '100%',
                            marginTop: 'var(--sizing-sm)'
                        }
                    }}>
                    درخواست پشتیبانی آنلاین
                </Button>
            </Box>

        </React.Fragment>

    );

}

export default OnlineSupport;